import Axios from 'axios'

export const RESPONSE_TYPES = {
  STATUS_OK: 200,
  STATUS_CREATED: 201,
  STATUS_NO_CONTENT: 204,
  STATUS_UNAUTHORIZED: 401
}

const ERRORS = {
  ERR_USER_EXISTS: 'user already exists with this email.',
}

class ApiConnectionHandler {
  constructor() {
    // Create the api
    this.api = Axios.create({
      baseURL: `${process.env.VUE_APP_API_URL}/api/`
    })
  }

  static getInstance() {
    if (this.instance == null) {
      this.instance = new ApiConnectionHandler()
    }
    return this.instance
  }

  send(method, url, headers = {}, data = {}, params = {}, arrayBufferResponse = false) {
    // Define the headers if they are undefined
    headers = headers !== undefined ? headers : {}
    // Create the http request and return the request
    return this.api.request({
      method: method,
      url: url,
      headers: headers !== undefined ? headers : {},
      data: data !== undefined ? data : {},
      params: params !== undefined ? params : {},
      withCredentials: true,
      responseType: arrayBufferResponse === true ? 'arraybuffer' : undefined
    })
  }

  get(url, headers = {}, params = {}, responseType = false) {
    return this.send('GET', url, headers, undefined, params, responseType)
  }

  post(url, headers = {}, data = {}, fileResponse = {}) {
    return this.send('POST', url, headers, data, undefined, fileResponse)
  }

  patch(url, headers = {}, data = {}, params = {}) {
    return this.send('PATCH', url, headers, data, params)
  }

  put(url, headers = {}, data = {}, params = {}) {
    return this.send('PUT', url, headers, data, params)
  }

  delete(url, header = {}, data = {}) {
    return this.send('DELETE', url, header, data)
  }

  isSuccess(statusCode) {
    return (
      statusCode === RESPONSE_TYPES.STATUS_OK ||
      statusCode === RESPONSE_TYPES.STATUS_CREATED ||
      statusCode === RESPONSE_TYPES.STATUS_NO_CONTENT
    )
  }

  getHeader() {
    return {'Content-Type' : 'text/plain'}
  }

  parseFormData(data) {
    let formData = new FormData()
    // get the first level of data
    for (const key in data) {
      if (Array.isArray(data[key])) {
        // here data[key] is an array, we need both index and value below
        for (const [index, value] of data[key].entries()) {
          // the value is an object, so loop through each key
          for (const childKey in value) {
            // parse the data to correct format for array of objects
            formData.append(`${key}[${index}].${childKey}`, value[childKey])
          }
        }
      } else {
        formData.append(key, data[key])
      }
    }
    return formData
  }

  parseNonArrayFormData(data) {
    let formData = new FormData()
    // get the first level of data
    for (const key in data) {
      if (!Array.isArray(data[key])) {
        formData.append(key, data[key])
      }
    }
    return formData
  }

  getRegisterErrorText(errorObj) {
    let text;

    if (errorObj.data) {
      text = errorObj.data[0].message
    } else {
      text = errorObj['message']
    }

    text = text.toLowerCase()
    // make the return text
    let returnText = ''

    if (text.includes(ERRORS.ERR_USER_EXISTS)) {
      returnText = 'User already exists with this email and/or name.'
    }

    return returnText;
  }

  setApiInterceptors(store) {
    // Add a request interceptor
    this.api.interceptors.request.use(
      function (config) {
        store.commit('resetRegisterFailure')
        store.commit('setLoading', true)
        // Do something before request is sent
        return config
      },
      function (error) {
        store.commit('setLoading', false)
        // Do something with request error
        return Promise.reject(error)
      }
    )
    // Add a response interceptor
    this.api.interceptors.response.use(
      function (response) {
        store.commit('setLoading', false)
        // Do something with response data
        return response
      },
      function (error) {
        store.commit('setLoading', false)
        // Do something with response error
        return Promise.reject(error)
      }
    )
  }
}

let apiHandler = ApiConnectionHandler.getInstance()

export default apiHandler
